<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterByNameAndContact')"/>
                </v-col>

                <v-col cols="2">
                    <v-combobox
                        outlined
                        hide-details
                        v-model="pagination.customerGroup"
                        append-icon="expand_more"
                        height="40px"
                        :items="filterableCustomerGroup"/>
                </v-col>
                <v-col cols="3">
                    <date-range-field
                        v-model="pagination.dateRange"/>
                </v-col>
                <v-col>
                    <v-btn
                        class="float-right"
                        color="primary">
                        {{ $t('button.exportXlsx') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <participant-table
                :search="pagination.search"
                :items="participants"
                :options="pagination"/>
        </v-card-text>
    </v-card>
</template>

<script>
import DateRangeField from '@/components/fields/DateRangeField'
import ParticipantTable from '@/components/tables/ParticipantTable'

export default {
    name: 'ParticipantListView',

    components: {
        DateRangeField,
        ParticipantTable
    },

    props: {
        participants: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            customerGroupList: [
                'Pi R Sqaure',
                'Pi R',
                'Proud Group',
                'Andamanda'
            ]
        }
    },

    computed: {
        filterableCustomerGroup () {
            return ['All Customer', ...this.customerGroupList]
        }
    }
}
</script>

<style lang="scss" scoped></style>
